// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"c117df2b","87":"b353944f","382":"44c2ab0c","451":"d190f750","453":"27f6326c","544":"119df909","784":"2000f116"}[chunkId] + ".chunk.js";
};